import axios from './axios';
import utils from '../libs/utils';

const MODULE_NAME_BIZ = 'v1/erp-business-web/';
const MODULE_NAME_BASE = 'v1/erp-base-web/';
const baseUrl = `${MODULE_NAME_BIZ}`;// 本地服务请求地址
// let resBaseUrl = '/insurance';
// resBaseUrl = 'http://172.20.0.83:9999';
const protocol = window.location.protocol;
let resBaseUrl = `${protocol}//xian.erp.dtp.linkdoc.com:9999`;// rd环境模拟地址
if (Location.host === 'erp.rd.linkdoc.com') {
  resBaseUrl = `${protocol}//xian.erp.dtp.linkdoc.com:9999`;// rd环境模拟地址
} else if (Location.host === 'erp.dtp.linkdoc.com') {
  resBaseUrl = `${protocol}//erp.xian.dtp.linkdoc.com:9999`;// 线上环境环境模拟地址
}


const instance = axios.create({
  baseURL: resBaseUrl,
});


export default {
  axios,
  insuranceRefund(params) {
    return instance.post('/insuranceRefund', utils.exchangeParams(params));
  },
  test(params) { // 基本预留函数
    console.log('baseUrl可能处理用，预留函数');

    return axios.get(`${baseUrl}dataDirect/goods/list/condition?${utils.exchangeParams(params)}`);
  },
  codeTableList(params) { // 代码表列表
    return axios.get(`${baseUrl}medicare/list?${utils.exchangeParams(params)}`);
  },
  insuranceToDiseaseList(params) { // 医保病种对应查询列表
    return axios.get(`${baseUrl}insurance/disease/listMIDisease?${utils.exchangeParams(params)}`);
  },
  insuranceToDiseaseEdit(params) { // 医保病种对应查询编辑
    return axios.post(`${baseUrl}insurance/disease/updateMIDisease`,
      utils.exchangeParams(params));
  },
  medicareCatalogueList(params) { // 目录列表
    return instance.get(`/drugList?${utils.exchangeParams(params)}`);
  },
  // insuranceCardUpdatedList(params) { // 医保卡密码修改记录
  //   return axios.get(`${baseUrl}/medicare/list?${utils.exchangeParams(params)}`);
  // },
  // getInsuranceCardInfo(params) { // 读取医保卡信息
  //   return axios.get(`${baseUrl}/medicare/list?${utils.exchangeParams(params)}`);
  // },
  insuranceCardUpdatedPwd(params) { //  医保卡密码修改
    return instance.post('/card/pwd',
      utils.exchangeParams(params));
  },
  getSettlementList(params) { // 月度结算列表
    return axios.get(`${MODULE_NAME_BIZ}insurance/settlement/list?${utils.exchangeParams(params)}`);
  },
  confirmSettlement(params) {
    return instance.post('/settlement/confirm', utils.exchangeParams(params));
  },

  getUserList(params) { // 查询条件个人信息
    return axios.get(`${baseUrl}insurance/user/list?${utils.exchangeParams(params)}`);
  },
  insuranceMonthStatement(params) { //  医保月度结算打印
    // return axios.get(`${MODULE_NAME_INS}/insurance/report/expenseDetail/export?${utils.exchangeParams(params)}`, {
    return instance.get(`/settlement/report/insuranceMonthStatement?${utils.exchangeParams(params)}`);
  },
  statement(params) { //  结算单
    // return axios.get(`${MODULE_NAME_INS}/insurance/report/expenseDetail/export?${utils.exchangeParams(params)}`, {
    return instance.get(`/settlement/report/statement?${utils.exchangeParams(params)}`);
  },
  declarationReconciliation(params) { //  结算月度申报表对帐表打印
    // return axios.get(`${MODULE_NAME_INS}/insurance/report/expenseDetail/export?${utils.exchangeParams(params)}`, {
    return instance.get(`/settlement/report/declarationReconciliation?${utils.exchangeParams(params)}`);
  },
  statementMonthCount(params) { // 结算月度汇总表打印
    // return axios.get(`${MODULE_NAME_INS}/insurance/report/expenseDetail/export?${utils.exchangeParams(params)}`, {
    return instance.get(`/settlement/report/statementMonthCount?${utils.exchangeParams(params)}`);
  },
  expenseDetailExport(params) { // 费用明细下载
    // return axios.get(`${MODULE_NAME_INS}/insurance/report/expenseDetail/export?${utils.exchangeParams(params)}`, {
    return instance.get(`/insurance/report/expenseDetail/export?${utils.exchangeParams(params)}`, {
      responseType: 'blob',
    });
  },
  settlementExport(params) { // 结算信息下载接
    // return axios.get(`${MODULE_NAME_INS}/insurance/report/settlement/export?${utils.exchangeParams(params)}`, {
    return instance.get(`/insurance/report/settlementInfo/export?${utils.exchangeParams(params)}`, {
      responseType: 'blob',
    });
  },
  monthSettlementExport(params) { // 月度结算下载
    // return axios.get(`${MODULE_NAME_INS}/insurance/report/monthSettlement/export?${utils.exchangeParams(params)}`, {
    return instance.get(`/insurance/report/monthSettlement/export?${utils.exchangeParams(params)}`, {
      responseType: 'blob',
    });
  },
  getNewNoticeList(params) { // 新公告列表
    return instance.get(`/notice/fetch?${utils.exchangeParams(params)}`);
  },
  noticeCheck(params) { // 公告确认
    return instance.post('/notice/handle', params);
  },
  // 历史公告列表
  getMiNoticeList(params) {
    return axios.get(`${baseUrl}mi/notice/list?${utils.exchangeParams(params)}`);
  },
  goodsMapList(params) { // 目录对应搜索
    return axios.get(`${MODULE_NAME_BASE}insurance/goodsMap/list?${utils.exchangeParams(params)}`);
  },
  goodsMapUpload(params) { // 上传未对应目录907
    return instance.get(`/goodsMap/upload?${utils.exchangeParams(params)}`);
  },
  goodsMapUpdate(params) { // 更新目录对码表908
    return instance.get(`/goodsMap/update?${utils.exchangeParams(params)}`);
  },
  goodsMapCancel(params) { // 更新目录对码表908
    return instance.get(`/cancel?${utils.exchangeParams(params)}`);
  },
  insuranceUser(params) {
    return instance.get(`/user?${utils.exchangeParams(params)}`);
  },
  specialDisease(params) {
    return instance.get(`/specialDisease?${utils.exchangeParams(params)}`);
  },
  // goodsMapList(params) { // 取消对应909
  //   return axios.get(`${baseUrl}insurance/goodsMap/list?${utils.exchangeParams(params)}`);
  // },
  // goodsMapList(params) { // 目录对应搜索
  //   return axios.get(`${baseUrl}insurance/goodsMap/list?${utils.exchangeParams(params)}`);
  // },
};
